import { css } from 'styled-components';
import { CFMixins } from '../../../../mixins';
import { CFBaseButtonTokens } from '../';
export const labelAlignment = ({ $alignment }) => $alignment === 'spread'
    ? css `
        flex: 1;
        text-align: left;
      `
    : css `
        text-align: center;
      `;
export const labelColor = ({ $disabled, $variant = 'primary', }) => $disabled
    ? CFBaseButtonTokens.COLORS.TEXT_DISABLED[$variant]
    : CFBaseButtonTokens.COLORS.TEXT[$variant];
export const labelTypeSpec = ({ $size }) => $size && Object.keys(CFBaseButtonTokens.TYPE_SPECS).includes($size)
    ? CFMixins.typeSpec(CFBaseButtonTokens.TYPE_SPECS[$size])
    : null;
export const interactionsLabelNative = ({ $disabled, $pressed, $variant, }) => css `
  ${$pressed && hoverTextEffect($disabled, $variant).cssFormat}
`;
export const interactionsLabelWeb = ({ $disabled, $variant, }) => css `
  a:hover &,
  button:hover & {
    content: '';
    ${hoverTextEffect($disabled, $variant).cssFormat};
  }
`;
export const hoverTextEffect = ($disabled, $variant) => {
    const textColor = $disabled
        ? CFBaseButtonTokens.COLORS.TEXT_DISABLED[$variant]
        : CFBaseButtonTokens.COLORS.TEXT_HOVER[$variant];
    return {
        cssFormat: css `
      color: ${textColor};
    `,
        textColorValue: textColor,
    };
};
